import { useScrollReveal } from '@/hooks/useScrollReveal';
import './HowItWorks.css';

export type HowItWorksStep = {
  number: string;
  title: string;
  body: string;
};

export type HowItWorksProps = {
  kicker?: string;
  title?: string;
  steps: HowItWorksStep[];
  /** Visual variant — `editorial` for white background, `methodology` for serif arrows. */
  variant?: 'editorial' | 'methodology';
};

export function HowItWorks({ kicker, title, steps, variant = 'editorial' }: HowItWorksProps) {
  const { ref, revealed } = useScrollReveal<HTMLDivElement>(0.15);
  const hasHead = Boolean(kicker || title);
  return (
    <section className="how-it-works">
      {hasHead ? (
        <div className="how-it-works__head">
          {kicker ? <div className="how-it-works__kicker">{kicker}</div> : null}
          {title ? <h2 className="how-it-works__title">{title}</h2> : null}
        </div>
      ) : null}
      <div
        ref={ref}
        className={[
          'how-it-works__grid',
          `how-it-works__grid--${variant}`,
          revealed ? 'is-revealed' : '',
        ].join(' ')}
        data-testid="how-it-works-grid"
      >
        {steps.map((step) => (
          <div key={step.number} className="how-it-works__step">
            <div className="how-it-works__number">
              {variant === 'methodology' ? '→ ' : ''}
              {step.number}
            </div>
            <div className="how-it-works__step-title">{step.title}</div>
            <div className="how-it-works__body">{step.body}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
